export default "__VITE_ASSET__ba9289b0__"